import { types } from '../../../constants/ActionTypes'

const initialState = {
  records: []
}

const chatMenu = (state = initialState, action) => {
  var records
  switch (action.type) {
    case types.comment.RESPONSE_SELECT:
      if (action.response.result === false) {
        return state
      }
      records = state.records.filter(record => record.id !== action.response.record.id)
      records.push(action.response.record)
      return {
        ...state,
        records,
      }
    default:
      return state
  }
}

export default chatMenu


// WEBPACK FOOTER //
// ./src/reducers/Common/Comment/Comment.js